// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'truck-cargo';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12.188 15.083a1.328 1.328 0 1 0 2.656 0 1.328 1.328 0 0 0-2.656 0zm-11.157 0a1.328 1.328 0 1 0 2.657 0 1.328 1.328 0 0 0-2.657 0zm15.407-2.248V8.443a3.187 3.187 0 0 0-3.188-3.187H9v7.437' />
    <path d='M3.688 15.083a1.328 1.328 0 1 0 2.656 0 1.328 1.328 0 0 0-2.657 0zM9 14.818v-2.125h6.906a1.063 1.063 0 0 1 0 2.125h-1.089M9 5.255V2.818a1.062 1.062 0 0 1 1.296-1.037c1.128.253 2.631.702 2.954 1.349.303.67.483 1.39.531 2.125V5.3m-6.906 6.33H1.031m15.407-1.594H9m3.188-4.781v4.781m-5.313 2.657V2.599a1.062 1.062 0 0 0-1.063-1.063h-4.78m11.182 13.282H6.316' />
  </g>
);

export const viewBox = '0 0 18 18';
